export default "__VITE_ASSET__ncALPYSq__"